// Active NextNavigationPrompt guards (App Router). A guard returns true to pause the navigation.
// Multiple guards can be registered at once (e.g. nested layouts); the first one to claim a
// navigation wins (OR semantics) — the rest are not consulted for that call.
export type TNavigationGuard = (url: string, replace: boolean) => boolean;

const guards = new Set<TNavigationGuard>();

export const registerNavigationGuard = (guard: TNavigationGuard): (() => void) => {
  guards.add(guard);
  return (): void => {
    guards.delete(guard);
  };
};

export const interceptNavigation = (url: string, replace: boolean): boolean => {
  for (const guard of guards) {
    if (guard(url, replace)) return true;
  }
  return false;
};
